/* Dokumen pindaian sebuah sumur, terutama scan dipmeter lama.
 *
 * Dipmeter sumur tahun 1970-an tidak pernah menjadi angka: yang tersisa plot
 * "computed results" yang dipindai. Daftar ini menaruhnya di samping citra
 * lubang bor supaya dip FMI modern dan dip HDT lama bisa dibandingkan tanpa
 * membuka portal lain. Berkasnya dibuka di tab baru, apa adanya.
 */

import { api, unpage, type Page } from "../api";
import { useAsync } from "../hooks";
import type { WellDocument } from "../types";
import { Panel } from "./ui";

export function useWellDocuments(wellId: number) {
  return useAsync(
    (signal) => api
      .get<Page<WellDocument>>("/api/well-documents/", { well: wellId }, signal)
      .then((page) => unpage(page, signal)),
    [wellId],
  );
}

function interval(doc: WellDocument): string {
  if (doc.top_md == null || doc.base_md == null) return "";
  return `${doc.top_md.toFixed(0)}–${doc.base_md.toFixed(0)} m`;
}

export function WellDocuments({ documents }: { documents: WellDocument[] }) {
  if (!documents.length) return null;
  return (
    <Panel title="Scanned documents" meta={`${documents.length}`} flush>
      <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
        {documents.map((doc) => (
          <li
            key={doc.id}
            style={{
              padding: "6px 10px",
              borderBottom: "1px solid var(--line)",
              font: "400 11.5px var(--font-sans)",
            }}
          >
            {doc.url ? (
              <a href={doc.url} target="_blank" rel="noreferrer" title={doc.source}>
                {doc.title}
              </a>
            ) : (
              <span>{doc.title}</span>
            )}
            <div style={{ color: "var(--ink-5)", marginTop: 2 }}>
              {[doc.kind_label, interval(doc)].filter(Boolean).join(" · ")}
            </div>
          </li>
        ))}
      </ul>
    </Panel>
  );
}
